import React from 'react';
import StringFieldProto from './string-proto.jsx';


export default function renderStringInEdit(id, props) {
    return <StringFieldProto renderMode="edit" id={id} {...props} />;
}